import { stories } from '@features/stories/model/query-keys'
import { DetailScreen } from '@features/stories/screens'
import { Layout } from '@layouts/Layout'
import { Order_By } from '@purposity/sdk'
import { ValidId } from '@purposity/utils'
import { QueryClient, dehydrate } from '@tanstack/react-query'
import { env } from 'env'
import { sdkAsAdmin } from 'lib/as-admin'
import type { GetStaticPaths, GetStaticProps } from 'next'
import * as React from 'react'
import type { NextPageWithLayout } from 'types/next'

const StoryDetailPage: NextPageWithLayout = DetailScreen

type Seconds = number
const CONSIDERED_STALE: Seconds = 1

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const id = await ValidId.parseAsync(params?.id)
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * CONSIDERED_STALE,
        cacheTime: Infinity,
      },
    },
  })

  const { queryKey, queryFn } = stories.detail(id)

  const data = await queryClient.fetchQuery(queryKey, queryFn, {
    meta: {
      headers: {
        'x-hasura-admin-secret': env.ADMIN_API_SECRET,
      },
    },
  })

  if (data.story === null) {
    return {
      notFound: true,
      revalidate: CONSIDERED_STALE,
    }
  }

  return {
    props: {
      id,
      dehydratedState: dehydrate(queryClient),
    },
    revalidate: CONSIDERED_STALE,
  }
}

export const getStaticPaths: GetStaticPaths = async () => {
  const sdk = sdkAsAdmin

  const data = await sdk.stories({
    limit: 1,
    order_by: { published_date: Order_By.DescNullsLast },
  })

  return {
    paths: data.stories.map((story) => ({
      params: { id: `${story.id}` },
    })),
    fallback: true,
  }
}

StoryDetailPage.getLayout = function getLayout(page: React.ReactElement) {
  return <Layout>{page}</Layout>
}

export default StoryDetailPage
